import { useGetFactorLimitsQuery } from '@/app/api';
import { FactorLimitsTable } from '@/features/factor-limits-table';
import { CabinetWrapper } from '@/shared/cabinet-wrapper';
import { PageTitle } from '@/shared/page-title';
import { EmptyDataPlaceholder } from '@/shared/ui/empty-data-placeholder';
import UITabs from '@/shared/ui/ui-tabs';
import { Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UITabItemLabel } from '../../shared/ui/ui-table/ui/tab-item-label';
import { Link } from 'react-router-dom';

export const FactorLimitsPage = () => {
  const { t } = useTranslation();
  const [limitsCount, setLimitsCount] = useState<{
    active: number;
    overdue: number;
    suspended: number;
  }>();

  const { data, isLoading } = useGetFactorLimitsQuery({
    page: 1,
    pageSize: 20,
  });

  return (
    <CabinetWrapper>
      <PageTitle title={t('limits_control')} noBack />

      <EmptyDataPlaceholder
        title={t('no_limits_placeholder_title')}
        subtitle={t('no_limits_placeholder_subtitle')}
        isEmpty={!isLoading && !data?.data?.length}
        isLoading={isLoading}
        endAdornment={
          <Link to='/factor/limits/clients'>
            <Button sx={{ height: 40 }}>{t('add_clients')}</Button>
          </Link>
        }
      >
        <UITabs
          sx={{ mt: 2.5 }}
          tabs={[
            {
              // label: t("factor_limits_tabs.all"),
              label: (
                <UITabItemLabel
                  label={t('factor_limits_tabs.all')}
                  count={
                    (limitsCount?.active || 0) +
                    (limitsCount?.overdue || 0) +
                    (limitsCount?.suspended || 0)
                  }
                />
              ),
              component: <FactorLimitsTable setLimitsCount={setLimitsCount} />,
            },
            {
              label: (
                <UITabItemLabel
                  label={t('factor_limits_tabs.active')}
                  count={limitsCount?.active || 0}
                />
              ),
              component: <FactorLimitsTable setLimitsCount={setLimitsCount} status='active' />,
            },
            {
              // label: t("factor_limits_tabs.overdue"),
              label: (
                <UITabItemLabel
                  label={t('factor_limits_tabs.overdue')}
                  count={limitsCount?.overdue || 0}
                />
              ),
              component: <FactorLimitsTable setLimitsCount={setLimitsCount} status='overdue' />,
            },
            {
              label: (
                <UITabItemLabel
                  label={t('factor_limits_tabs.suspended')}
                  count={limitsCount?.suspended || 0}
                />
              ),
              component: <FactorLimitsTable setLimitsCount={setLimitsCount} status='suspended' />,
            },
          ]}
        />
      </EmptyDataPlaceholder>
    </CabinetWrapper>
  );
};
